{
  "page_count": "共 {n, plural, one{# 页} other{# 页}}"
}
